export const LIGHT_COLORS = {
  background: "#f6f6f6",
  primary: "#178CA4",
  secondary: "#18B7BE",
  accent: "#104059",
  error: "#ff5722",
  warning: "#ffc107",
  info: "#3f51b5",
  success: "#43A047",
};

export const DARK_COLORS = {
  background: "#131313",
  primary: "#00739e",
  secondary: "#B2EBF2",
  accent: "#104059",
  error: "#ff5722", 
  warning: "#ffc107",
  info: "#3f51b5",
  success: "#66BB6A"
};